/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.1.3 .\public\luffy.glb
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(
    "/Kiran-Portfolio/luffy.glb",
  );
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    actions.dance.play();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <group
          name="Armature"
          position={[0.1, -0.06, 0.07]}
          rotation={[-0.07, -0.04, 0.11]}
        >
          <primitive object={nodes.unused100} />
          <skinnedMesh
            name="21_+Eyes_1_0_0"
            geometry={nodes["21_+Eyes_1_0_0"].geometry}
            material={materials["lambert3.003"]}
            skeleton={nodes["21_+Eyes_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_+Hair_1_0_0"
            geometry={nodes["21_+Hair_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_+Hair_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_+HatBack_1_0_0"
            geometry={nodes["21_+HatBack_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_+HatBack_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_-Hat_1_0_0"
            geometry={nodes["21_-Hat_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_-Hat_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_eyeunder_1_0_0"
            geometry={nodes["21_eyeunder_1_0_0"].geometry}
            material={materials["lambert4.003"]}
            skeleton={nodes["21_eyeunder_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_sash_1_0_0"
            geometry={nodes["21_sash_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_sash_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_shirt_1_0_0"
            geometry={nodes["21_shirt_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_shirt_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_shorts2_1_0_0"
            geometry={nodes["21_shorts2_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_shorts2_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_shorts_1_0_0"
            geometry={nodes["21_shorts_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_shorts_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_skin_1_0_0"
            geometry={nodes["21_skin_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_skin_1_0_0"].skeleton}
          />
          <skinnedMesh
            name="21_teeth_1_0_0"
            geometry={nodes["21_teeth_1_0_0"].geometry}
            material={materials["LuffyD.003"]}
            skeleton={nodes["21_teeth_1_0_0"].skeleton}
          />
        </group>
        <group name="Luffy" rotation={[Math.PI / 2, 0, 0]} scale={0.01}>
          <group name="Sombrero" />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/Kiran-Portfolio/luffy.glb");
